import { render, staticRenderFns } from "./VariantSlider.vue?vue&type=template&id=67332fee&scoped=true&"
import script from "./VariantSlider.vue?vue&type=script&lang=js&"
export * from "./VariantSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67332fee",
  null
  
)

export default component.exports